import React from 'react';

export default React.createContext({
  formikRef: {},
  handleSubmit: () => {},
  handleChange: () => {},
  handleBlur: () => {},
  values: {},
  errors: {},
  touched: {},
});
